var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "autocomplete", attrs: { id: "parent" } }, [
    _vm.selectable == false
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.content,
              expression: "content"
            }
          ],
          style: "width:" + _vm.width,
          attrs: {
            id: "auto" + _vm.index,
            autocomplete: "off",
            tabindex: -1,
            type: "text"
          },
          domProps: { value: _vm.content },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.content = $event.target.value
              },
              _vm.onChange
            ],
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                return _vm.onArrowDown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                return _vm.onArrowUp.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "escape",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.clear.apply(null, arguments)
              }
            ]
          }
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.content,
              expression: "content"
            }
          ],
          style: "width:" + _vm.width,
          attrs: { id: "auto" + _vm.index, autocomplete: "off", type: "text" },
          domProps: { value: _vm.content },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.content = $event.target.value
              },
              _vm.onChange
            ],
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                return _vm.onArrowDown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                return _vm.onArrowUp.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "escape",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.clear.apply(null, arguments)
              }
            ]
          }
        }),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen"
          }
        ],
        staticClass: "autocomplete-results",
        style: { position: _vm.fixed == true ? "fixed" : "absolute" },
        attrs: { tabindex: -1, id: "autocomplete-results" }
      },
      [
        _vm.isLoading
          ? _c("li", { staticClass: "loading", attrs: { tabindex: -1 } }, [
              _vm._v("\n            Loading results...\n        ")
            ])
          : _vm._l(_vm.results, function(result, i) {
              return _c(
                "li",
                {
                  key: i,
                  staticClass: "autocomplete-result",
                  class: { "is-active": i === _vm.arrowCounter },
                  attrs: { tabindex: -1 },
                  on: {
                    click: function($event) {
                      return _vm.setResult(i)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(result) + "\n        ")]
              )
            })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-029fb607", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029fb607","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/autocomplete.vue
// module id = 795
// module chunks = 0